import { render, staticRenderFns } from "./dist-select.vue?vue&type=template&id=61c74b68"
import script from "./dist-select.vue?vue&type=script&lang=js"
export * from "./dist-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports